import { useRef, useEffect } from 'react';

interface HorizontalVideoSectionProps {
  src: string;
  headline?: string;
  zIndex?: number;
}

function useVideoAutoplay(ref: React.RefObject<HTMLVideoElement | null>) {
  useEffect(() => {
    const video = ref.current;
    if (!video) return;
    const play = () => video.play().catch(() => {});
    play();
    const onVisible = () => { if (!document.hidden) play(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []);
}

/** Full-width horizontal video (e.g. unboxing). */
export default function HorizontalVideoSection({
  src,
  headline,
  zIndex = 71
}: HorizontalVideoSectionProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  useVideoAutoplay(videoRef);

  return (
    <section
      className="relative w-full bg-[var(--vyera-cream)] py-6 sm:py-10"
      style={{ zIndex }}
    >
      <div className="w-full aspect-video overflow-hidden">
        <video
          ref={videoRef}
          src={src}
          className="w-full h-full object-cover"
          muted
          loop
          playsInline
          aria-label="VYERA unboxing"
        />
      </div>
      {headline && (
        <p className="vyera-heading-md text-[var(--vyera-text-primary)] text-center mt-4 sm:mt-6 px-4">
          {headline}
        </p>
      )}
    </section>
  );
}
